<section>
  <div>
    <form [formGroup]="posOrderFormGroup" id="payment-form" style="padding:0px;" class="col-xs-12" novalidate>
      <div class="order-promotion-block">
        <div class="restrict-order-message" *ngIf="memberInfo && !isActive && memberStatus">
          *{{'customer-service.Creating new orders is not permitted for members in this status' |translate}}.&nbsp;{{'customer-service.Member Status is' |translate}}&nbsp;
          <span *ngIf="memberStatus">{{memberStatus.name}}</span>
          <span *ngIf="!memberStatus">{{'customer-service.NA' |translate | translateKey}}</span>
        </div>
        <div class="row-sameheight-block mtb-20">
          <div class="column-equal grayborder-1 flex-left-59">
            <div class="col-xs-12 col-sm-6 form-group padding-left-0 floating-input floatLabelContainer">
              <input [attr.disabled]="orderFromLookup ? '':(isPaymentBlockEnabled ? true: null)"  float-label type="text" id="memberInfo"
                (keydown)="onKeydown($event)" (blur)="searchMember()" placement="right" class="form-control"
                (paste)="onPasteEvent()" placeholder="{{'order.Enter FBO ID or Email'|translate}}"
                formControlName="memberInfo">
              <div class="alert-msg"
                *ngIf="!posOrderFormGroup.controls['memberInfo'].valid && (posOrderFormGroup.controls['memberInfo'].touched || memberSearchSubmitted || orderSubmitted)">
                {{'order.Member Details are mandatory' |translate |translateKey}}</div>

              <div class="alert-msg"
                *ngIf="posOrderFormGroup.controls['memberInfo'].hasError('searchByMemberValidation')">
                {{'validation-message.Enter valid FBO ID / Email '|translate}}
              </div>
              <div class="alert-msg"
                *ngIf="showPOSOrderValidation && posOrderFormGroup.controls['memberInfo'].valid && !posOrderFormGroup.controls['memberInfo'].hasError('searchByMemberValidation')">
                {{'validation-message.Member not eligible for POS orders'|translate}}
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 padding-left-0 float-right floating-input">
              <select [attr.disabled]="isPaymentBlockEnabled || isSingleDistributionCenter ? true: null" #posLocation id="posLocation" class="form-control" formControlName="posLocation"
                (change)="changePosLocation($event.target.value)">
                <option [disabled]="true" value='0'>{{'order.Change POS Location' |translate |translateKey}}</option>
                <option *ngFor="let posLocation of posLocations | orderBy:'name'" [value]="posLocation.id">
                  {{posLocation.name}}
                </option>
              </select>
              <div class="alert-msg"
                *ngIf="!posOrderFormGroup.controls['posLocation'].valid && (posOrderFormGroup.controls['posLocation'].touched || orderSubmitted)">
                {{'order.Pos Location Details are mandatory' |translate |translateKey}}</div>
            </div>

            <div class="col-md-12 col-xs-12  padding-left-0" *ngIf="memberInfo">
              <div class="column-equal member-details-block word-break--overflow">
                <div class="">
                  <div class="row">
                    <div class="col-md-6 col-xs-12">
                      <div class="row padding-left-22">
                        <span class="color-blue uppercase">{{'order.MEMBER DETAILS' |translate
                          |translateKey}}</span>
                        <div *ngIf="memberInfo && memberInfo.firstName">
                          <div class="bold header-font color-black margin-12">
                            <span>{{memberInfo | displayNameFormat}}</span>
                          </div>
                          <div *ngIf="memberInfo.displayName && memberInfo.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                            <span>{{memberInfo.displayName | titlecase}}</span>
                        </div>
                          <div class="font14">
                            <a  *ngIf="memberInfo?.fboId"><i class="fa fa-copy" [copyToClipboard]="memberInfo?.fboId"></i></a>
                            <span *ngIf="memberInfo"><span>{{memberInfo?.fboId |
                                                                distributorIdFormat}}</span> |<span
                                class="color-black">
                                {{memberInfo?.memberTitle | uppercase}}</span></span>
                          </div>
                        </div>
                      </div>
                      <div class="row padding-left-22 margin-15">
                        <span class="color-blue uppercase">{{'order.SPONSOR DETAILS' |translate
                            |translateKey}}</span>
                        <div class="font14 font-weight-550">
                          <span *ngIf="memberInfo?.sponsorId">
                            <a *ngIf="memberInfo?.sponsorId"><i class="fa fa-copy"  [copyToClipboard]="memberInfo?.sponsorId" ></i></a>
                            <span class="color-black"> {{memberInfo?.sponsorId  | distributorIdFormat}} </span>
                            <span class="color-black"> | {{memberInfo?.sponsorName | uppercase }}</span>
                          </span>
                          <span *ngIf="!memberInfo?.sponsorId"> {{'order.NA' |translate |translateKey}} </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 col-xs-12">
                      <span class="color-blue uppercase">{{'order.ACCOUNT INFORMATION' |translate
                                            |translateKey}}</span>
                      <div>
                        <div class="font14 ">
                          <span>Status</span>
                          <span class="float-right">{{memberStatus?.name}}</span>
                          <span class="float-right"
                            *ngIf="!memberStatus?.name">{{'order.NA' |translate |translateKey}}</span>
                        </div>
                        <div class="font14">
                          <span>Enrollment Date</span>
                          <span class="float-right">{{memberInfo?.enrolmentDate | date: 'dd-MMM-yyyy'}}</span>
                          <span class="float-right"
                            *ngIf="!memberInfo?.enrolmentDate">{{'order.NA' |translate |translateKey}}</span>
                        </div>
                        <div class="font14 ">
                          <span>Email</span>
                          <span class="float-right color-blue">{{memberInfo?.email}}</span>
                          <span class="float-right"
                            *ngIf="!memberInfo?.email">{{'order.NA' |translate |translateKey}}</span>
                        </div>
                        <div class="font14">
                          <span>Mobile Phone</span>
                          <span class="float-right">{{memberInfo?.mobile | mask: phoneNumberFormat}}</span>
                          <span class="float-right"
                            *ngIf="!memberInfo?.mobile">{{'order.NA' |translate |translateKey}}</span>
                        </div>
                        <div class="font14">
                          <span>Home Phone</span>
                          <span class="float-right">{{memberInfo?.phone | mask: phoneNumberFormat}}</span>
                          <span class="float-right"
                            *ngIf="!memberInfo?.phone">{{'order.NA' |translate |translateKey}}</span>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>
            <ng-container *ngIf="!isPaymentBlockEnabled">
              <div class="col-xs-12 col-sm-6 padding-left-0 clearboth">
                <div class="quick-add-block position-relative">
                  <div class="overlay-label">{{'order.Quick Add by Item# or Name' |translate |translateKey}}</div>
                  <input formControlName="itemSearch" ngui-auto-complete display-property-name="itemSearch"
                    (valueChanged)="onItemSelect()" [source]="observableSource.bind(this)" [max-num-list]="7"
                    [tab-to-select]="false" [select-on-blur]="false" [min-chars]="2" [re-focus-after-select]="false"
                    [list-formatter]="autocompleListFormatter" class="form-control" id="seachItemElement"
                    #seachItemElement placeholder="Suggestions appear after 2 letter input" (focus)="checkMemberAccess()"
                    [readonly]="!isMemberHasAccessToOrder || isMemberEligibleToPlaceOrder" />
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="isPaymentBlockEnabled ">
            <button type="button" role="button" [disabled]="placeOrderClicked" (click)="onEditCartClick()" class="btn blue-button">Click To Edit Cart</button>
            </ng-container>

          </div>
        </div>
        <div>

        <!-- Start account Restriction Popup-->
        <div *ngIf="accountRestriction">
          <account-restriction-popup [memberDetails]="memberDetails" (closeModal)="closeModal($event)"></account-restriction-popup>
        </div>
        <!-- End account Restriction Popup-->

          <!-- order grid -->
          <div class="table-responsive mb-20 quanity-increment-table">
            <table class="table table-striped custab">
              <thead>
                <tr>
                  <th>
                    <strong>{{'customer-service.Item #' |translate}}
                    </strong>
                  </th>
                  <th class="">
                    <strong>{{'customer-service.Product Description' |translate |translateKey}}
                    </strong>
                  </th>
                  <th class="">
                    <strong>{{'customer-service.Product Image' |translate}}
                    </strong>
                  </th>
                  <th class="">
                    <strong>{{'customer-service.Unit Price' |translate}}
                    </strong>
                  </th>
                  <th class="w-250 text-center">
                    <strong>{{'customer-service.Quantity' |translate |translateKey}}
                    </strong>
                  </th>
                  <th class="text-center">
                    <strong>{{'customer-service.Total CC' |translate |translateKey}}

                    </strong>
                  </th>
                  <th class="text-center">
                    <strong>{{'customer-service.Total Price' |translate |translateKey}}
                    </strong>
                  </th>
                  <th class="text-center">
                    <strong>{{'customer-service.Remove' |translate |translateKey}}</strong>
                  </th>

                </tr>
              </thead>
              <tbody formArrayName="items" *ngIf="posOrderFormGroup.get('items').value.length">
                <tr *ngFor="let item of getFormControls(); let i = index;" class="items height-78" [formGroupName]="i">
                  <!-- Item # -->
                  <td>
                    <span *ngIf ="!posOrderFormGroup.controls['items'].controls[i].controls['isDepositFeeProduct'].value">
                      {{posOrderFormGroup.controls['items'].controls[i].controls['productNumber'].value}}
                    </span> 
                  </td>
                  <input type="hidden" formControlName="itemNumber">
                  <input type="hidden" formControlName="productId">
                  <input type="hidden" formControlName="productItem">

                  <!-- Product Description -->
                  <td>{{posOrderFormGroup.controls['items'].controls[i].controls['productName'].value}}</td>
                  <!-- Unit Price -->
                  <td class=""><img width="60px" role="img" err-img
                      src="{{posOrderFormGroup.controls['items'].controls[i].controls['productImage'].value}}"
                      alt="product image" /></td>
                  <td class="">
                    <label *ngIf="posOrderFormGroup.controls['items'].controls[i].controls['productItem']&&
                    posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value &&
                    posOrderFormGroup.controls['items'].controls[i].controls['quantity'] &&
                    posOrderFormGroup.controls['items'].controls[i].controls['quantity'].value">
                      <ng-container
                        *ngIf="memberTypeId != memberTypeEnum.RETAIL && memberTypeId != memberTypeEnum.GUEST else retailOrder">
                        <span *ngIf="(displayPriceConfig && displayPriceConfig.displayApplicablePrice)">
                          {{posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.applicablePrice
                                                        | currencyFormat:storeInfo}}
                        </span>
                        <span *ngIf="(displayPriceConfig && displayPriceConfig.displayComputedTaxInclusivePrice)">
                          {{posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.computedTaxInclusivePrice
                                                        | currencyFormat:storeInfo}}
                        </span>
                        <span *ngIf="(displayPriceConfig && displayPriceConfig.displayCatalogPrice)">
                          {{posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.catalogPrice
                                                        | currencyFormat:storeInfo}}
                        </span>
                      </ng-container>
                      <ng-template #retailOrder>
                        <span
                          *ngIf="(displayPriceConfig && displayPriceConfig.displayCatalogPrice) else applicablePrice">
                          {{posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.catalogPrice
                                                        | currencyFormat:storeInfo}}
                        </span>
                        <ng-template #applicablePrice>{{posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.applicablePrice
                                                    | currencyFormat:storeInfo}}</ng-template>
                      </ng-template>
                    </label>
                    <app-price-popover
                      *ngIf="memberTypeId != memberTypeEnum.RETAIL && memberTypeId != memberTypeEnum.GUEST&&memberDiscountPercentage
                                        && posOrderFormGroup.controls['items'].controls[i].controls['productItem']&&
                                        posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value && !(posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.applicablePrice === posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.retailPrice)"
                      tabindex="0" [memberInfo]="memberInfo" [storeInfo]="storeInfo"
                      [memberDiscountPercentage]="memberDiscountPercentage"
                      [product]="posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value"
                      [displayPriceConfig]="displayPriceConfig"></app-price-popover>
                    <label class="srp" *ngIf="posOrderFormGroup.controls['items'].controls[i].controls['productItem']&&
                    posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value &&
                    posOrderFormGroup.controls['items'].controls[i].controls['quantity'] &&
                    posOrderFormGroup.controls['items'].controls[i].controls['quantity'].value && memberTypeId != memberTypeEnum.RETAIL && memberTypeId != memberTypeEnum.GUEST
                                                 && !(posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.applicablePrice === posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.retailPrice)
                                                 && !displayPriceConfig?.displayBaseRetailPrice">
                      {{(posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.retailPrice)
                                            | currencyFormat:storeInfo}}
                    </label>

                    <label class="srp" *ngIf="posOrderFormGroup.controls['items'].controls[i].controls['productItem']&&
                    posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value &&
                    posOrderFormGroup.controls['items'].controls[i].controls['quantity'] &&
                    posOrderFormGroup.controls['items'].controls[i].controls['quantity'].value && memberTypeId != memberTypeEnum.RETAIL && memberTypeId != memberTypeEnum.GUEST
                                                 && !(posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.applicablePrice === posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.retailPrice)
                                                 && displayPriceConfig?.displayBaseRetailPrice">
                      {{(posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.baseRetailPrice)
                                            | currencyFormat:storeInfo}}
                    </label>
                  </td>
                  <!-- Quantity Block -->
                  <td class="quanity-block">
                    <ng-container *ngIf="!isPaymentBlockEnabled">
                      <div class="col-md-2 no-padding no-border" *ngIf ="!posOrderFormGroup.controls['items'].controls[i].controls['isDepositFeeProduct'].value">
                        <span
                          [ngClass]="{'disableDecrement':(disableQty || posOrderFormGroup.controls['items'].controls[i].controls['quantity'].value==1||!posOrderFormGroup.controls['items'].controls[i].controls['quantity'].value)}"
                          class="fa fa-minus qtyminus" (mousedown)="disablePaymentDetailButton()" (click)="decrementQuantity(i)"
                          (keyup.enter)="moveToItemLevelSearchBlock($event)">
                          <label class="visuallyhidden">{{'order.decrement Quantity button'|translate |translateKey}}>
                          </label>
                        </span>
                      </div>
                      <div class="col-md-6 no-padding" *ngIf ="!posOrderFormGroup.controls['items'].controls[i].controls['isDepositFeeProduct'].value">
                        <input id="quantity-{{i}}" aria-label="quantity" min="1" [ngClass]="{'disableDecrement': disableQty}"
                        (focus)="setPreviousQuantity(posOrderFormGroup.controls['items'].controls[i].controls['quantity'].value)"
                          (blur)="updateQuantity($event,i)" class="quanity form-control quantity-{{i}}" maxlength="3"
                          formControlName="quantity" (keypress)="allowOnlyNumbers($event); disablePaymentDetailButton();"
                          (onfocusout)="updateQuantity($event,i)" (keydown)="quantityChange($event, i)"
                          (keyup)="quantityChange($event, i)" type="text"
                          (keyup.enter)="moveToItemLevelSearchBlock($event)" (change)="onQuantityChange($event)">
                        <div aria-live="assertive" class="alert-msg"
                          *ngIf="!posOrderFormGroup.controls['items'].controls[i].controls['quantity'].valid&&posOrderFormGroup.controls['items'].controls[i].controls['quantity'].hasError('required')&& (posOrderFormGroup.controls['items'].controls[i].controls['quantity'].touched || orderSubmitted)">
                          {{'order.Enter Quantity' | translate | translateKey}}!
                        </div>
                      </div>
                      <div class="col-md-2 no-padding" *ngIf ="!posOrderFormGroup.controls['items'].controls[i].controls['isDepositFeeProduct'].value">
                        <span class="fa fa-plus qtyplus" (mousedown)="disablePaymentDetailButton()"
                          (click)="incrementQuantity(i)"
                          [ngClass]="{'disableDecrement': (disableQty || posOrderFormGroup.controls['items'].controls[i].controls['disableIncrement'].value )}"
                          (keyup.enter)="moveToItemLevelSearchBlock($event)">
                          <label class="visuallyhidden">{{'order.increment Quantity button'|translate |translateKey}}
                          </label>
                        </span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="isPaymentBlockEnabled && !posOrderFormGroup.controls['items'].controls[i].controls['isDepositFeeProduct'].value">
                      {{posOrderFormGroup.controls['items'].controls[i].controls['quantity'].value}}
                    </ng-container>
                  </td>
                  <!-- Total CC -->
                  <td class="text-center">
                    <label class=""
                      *ngIf="posOrderFormGroup.controls['items'].controls[i].controls['productItem']&&
                                                    posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value &&
                                                    posOrderFormGroup.controls['items'].controls[i].controls['quantity'] &&
                                                    posOrderFormGroup.controls['items'].controls[i].controls['quantity'].value &&
                                                    !posOrderFormGroup.controls['items'].controls[i].controls['isDepositFeeProduct'].value">
                      <!-- {{(posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.commissionableVolume)}} -->
                      {{(posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value.commissionableVolume
                                            * posOrderFormGroup.controls['items'].controls[i].controls['quantity'].value)
                                            | ccFormat:storeInfo:false}}
                    </label>
                  </td>
                  <!-- Total Price -->
                  <td class="text-center">
                    <label *ngIf="posOrderFormGroup.controls['items'].controls[i].controls['productItem']&&
                                    posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value &&
                                    posOrderFormGroup.controls['items'].controls[i].controls['quantity'] &&
                                    posOrderFormGroup.controls['items'].controls[i].controls['quantity'].value">
                      {{ getItemTotalSum(posOrderFormGroup.controls['items'].controls[i].controls['productItem'].value)  | currencyFormat:storeInfo }}
                    </label>
                  </td>
                  <!-- Remove Button -->
                  <td class="options text-center">
                    <ng-container *ngIf="!isPaymentBlockEnabled">
                      <button type="button" (click)="deleteItem(i)" class="btn-link item-trash-link no-padding"
                      *ngIf ="!posOrderFormGroup.controls['items'].controls[i].controls['isDepositFeeProduct'].value"
                      tabindex="-1">
                      <i class="fa fa-trash"></i>
                    </button>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
              <ng-container *ngIf="!isPaymentBlockEnabled">
                  <tbody class="border-top-0">
                    <tr>
                      <td class="height-78">
                        <input #itemLevelSearch id="itemLevelSearch" role="textbox" tabindex="0" class="itemLevelSearch"
                          placeholder="{{'customer-service.Item #' | translate |translateKey}}"
                          [readonly]="!isMemberHasAccessToOrder || isMemberEligibleToPlaceOrder" formControlName="itemLevelSearch" type="text"
                          (blur)="itemLevelSearchEvent($event)" (keypress)="disablePaymentDetailButton();">
                      </td>
                      <td class="outline-none" tabindex="0"></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
              </ng-container>
            </table>
          </div>
          <div class="text-center" *ngIf="hasPOSOrderPermissions && enableBackDateOrder"  >
            <input id="backDateOrder" name="backDateOrder" formControlName="backDateOrder" tabindex="0" 
              [attr.disabled]="isPaymentBlockEnabled == true ?'disabled': null" type="checkbox" (click)="backDateOrderChange($event)">
            <label class="backDateOrderLabel">
                &nbsp;{{'customer-service.Backdate Order to last day of previous month' |translate |translateKey}}
            </label>
          </div>
          <div *ngIf="displayTryAgain">
            <button type="button" role="button" class="btn blue-button" (click)="createOrder()">
              {{'order.Please try again' | translate | translateKey}}
            </button>
          </div>
          <div *ngIf="!displayTryAgain">
            <button type="button" role="button" [hidden]="isPaymentBlockEnabled" [disabled]="taxCalculationStatus && (!posOrderFormGroup.controls['posLocation'].valid || !posOrderFormGroup.controls['memberInfo'].valid || (cartItems.length < 1) || isEnterPaymentDetailsEnabled || isPaymentBlockEnabled) || cartLimitNotReach" (click)="createOrder()" class="btn blue-button">+Enter Payment Details</button>
          </div>
          <div class="row-sameheight-block">
            <div class="column-equal grayborder-1 mt-20 flex-left-40 widget-border payment-details-block variable-height" *ngIf="isPaymentBlockEnabled">
              <div class="row margin-5" >
                <div class="col-xs-3 radiobutton-label">
                  <span class="color-blue">{{'order.PAYMENT DETAILS' | translate | translateKey}}</span>
                </div>
                <div class="col-xs-9 radio-buttons">
                  <div>
                    <span *ngFor="let paymentGroup of posPaymentGroups;let k = index;">
                      <input id={{paymentGroup.id}} formControlName="paymentSelector" name="paymentSelector"
                        [value]="paymentGroup.id" [checked]="paymentGroup.id === posPaymentGroupEnum.External_Payment ? true : k===0" type="radio" (change)="onPaymentMethodGroupChange(paymentGroup.id)">
                      <label class="pr-10">{{paymentGroup.name}}</label>
                    </span>
                  </div>
                </div>
              </div>
              <div *ngIf="posPaymentGroups && posPaymentGroups.length>0">
                <!-- External payment section starts -->
                <div class="row no-margin">
                  <div *ngIf="externalPaymentForm && externalPaymentForm.controls['payments'].length > 0 && +posOrderFormGroup.controls['paymentSelector'].value===posPaymentGroupEnum.External_Payment">
                    <div class="pl-15">
                      {{'Remaining Amount: '}}<span [ngClass]="balanceOrderTotal === 0 ? 'text-blue' : 'text-red' ">{{storeInfo.currencySymbol}} {{balanceOrderTotal | number :'1.2-2'}}</span>
                    </div>
                    <form [formGroup]="externalPaymentForm">
                      <div formArrayName="payments">
                        <div class="payment-border-bottom pl-15"
                          *ngFor="let paymentForm of externalPaymentForm.controls['payments'].controls; let e=index">
                          <div [formGroupName]="e">
                            <div class="radio-buttons payment-padding-top ">
                              <div class="radiobutton-group">
                                <span>
                                  <input id="paymentMethodId-{{e}}" formControlName="paymentMethodId" name="paymentMethodId"
                                   [value]="getPaymentMethodId(posPaymentGroupEnum.External_Payment,e)" [checked]="e===0 ? true : false"
                                    type="radio" (change)="onExternalPaymentMethodChange($event,posPaymentGroupEnum.External_Payment,e)" />
                                  <label>{{getPaymentMethodName(posPaymentGroupEnum.External_Payment,e)}}</label>
                                </span>
                              </div>
                            </div>
                            <input hidden formControlName="paymentStatus">
                            <div class="form-inline">
                              <label>{{'Enter Amount'}}</label>
                              <input class="form-control quanity" id="amount-{{e}}" formControlName="amount" name="amount" type="text" [dropSpecialCharacters]="false" mask="0*.00" (keypress)="allowOnlyDecimalValues($event,posPaymentGroupEnum.External_Payment,e)"
                              (keydown)="onPaymentMethodAmountChange($event,posPaymentGroupEnum.External_Payment,e)" (keyup)="onPaymentMethodAmountChange($event,posPaymentGroupEnum.External_Payment,e)" placeholder="Amount" />
                                <div class="alert-msg"  *ngIf="externalPaymentForm.controls['payments'].controls[e].controls['amount'].hasError('required')">
                                  {{'Enter Amount'}}
                                </div>
                            </div>
                            <div class="pr-10 pt-10">
                              <ng-container *ngIf="externalPaymentForm.controls['payments'].controls[e].controls['paymentMethodId'].value && +externalPaymentForm.controls['payments'].controls[e].controls['paymentMethodId'].value === posPaymetMethodsEnum.Credit_Card_External">
                                <label>{{'Card last 4 digits / Authourization code'}}</label>
                                <input class="form-control" id="paymentNote-{{e}}" formControlName="paymentNote" name="paymentNote" type="text"  placeholder="Note" />
                              </ng-container>
                              <ng-container *ngIf="!(externalPaymentForm.controls['payments'].controls[e].controls['paymentMethodId'].value && +externalPaymentForm.controls['payments'].controls[e].controls['paymentMethodId'].value === posPaymetMethodsEnum.Credit_Card_External)" >
                                <input hidden formControlName="paymentNote">
                              </ng-container>
                            </div>
                            <ng-container *ngIf="displayPaymentCheckNumber(e)" else hideNoteField>
                              <label>{{'Enter Check Number'}}</label>
                              <input class="form-control" id="paymentCheckNumber-{{e}}" formControlName="paymentCheckNumber" name="paymentCheckNumber" type="text"  placeholder="Enter Check Number" />
                              <div class="alert-msg"  *ngIf="externalPaymentForm.controls['payments'].controls[e].controls['paymentCheckNumber'].hasError('maxlength')">
                                {{'length should be max 15 characters'}}
                              </div>
                            </ng-container>
                            <ng-template #hideNoteField>
                              <input hidden formControlName="paymentNote">
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <!-- External payment section end -->

                <!-- Saved cards payments starts -->
                <div>
                  <div class="col-xs-12 radio-buttons" *ngIf="+posOrderFormGroup.controls['paymentSelector'].value===posPaymentGroupEnum.Integrated_Payments">
                    <div class="row margin-5-10"
                      *ngIf="(posOrderFormGroup.controls['paymentSelector'].value == posPaymentGroupEnum.Integrated_Payments) && credit_Card_show">
                      <div class="" *ngIf="paymentMethodTypeForm">
                        <form class="col-12 px-0" novalidate [formGroup]="paymentMethodTypeForm">
                          <div class="row" *ngFor="let paymentMethod of integratedPaymentMethods">
                            <div class="col-md-4">
                              <label class="pointer mb-2" role="radio" attr.aria-label="" tabindex="0">
                                <input role="radio" tabindex="-1" type="radio" name="paymentMethodType" formControlName="paymentMethodType"
                                  [value]="paymentMethod.paymentMethodsModel.paymentMethodId"
                                  (keyup.control.space)="selectPaymentMethodType(paymentMethod)"
                                  (click)="selectPaymentMethodType(paymentMethod)" (keyup.enter)="selectPaymentMethodType(paymentMethod)"
                                  (change)="selectPaymentMethodType(paymentMethod)" [checked]="">
                                <span tabindex="0" (keyup.control.space)="selectPaymentMethodType(paymentMethod)"
                                  (keyup.enter)="selectPaymentMethodType(paymentMethod)" (change)="selectPaymentMethodType(paymentMethod)"
                                  attr.aria-label="{{paymentMethod.paymentMethodsModel.paymentMethodName}}" role="radio"
                                  class="label-text">{{paymentMethod.paymentMethodsModel.paymentMethodName}}</span>
                              </label>
                            </div>
                            <div class="col-md-4 terminal-dropdown" *ngIf="(terminalOptions && terminalDownConfig) && isTerminalSelected && paymentMethod.paymentMethodsModel.paymentMethodId === paymentTypeEnum.INTEGRATED_TERMINAL">
                              <ng-selectize [config]="terminalDownConfig" formControlName="preselectTerminal" [options]="terminalOptions"
                                (ngModelChange)="terminalSelection($event)"
                                placeholder="{{'user.Click to select...' | translate | translateKey}}">
                              </ng-selectize>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div *ngIf="paymentMethodTypeForm && paymentMethodTypeForm.controls['paymentMethodType']">
                        <div class="col-xs-12 floating-input customFocus"
                          *ngIf="paymentMethodTypeForm.controls['paymentMethodType'].value==paymentTypeEnum.Pay_By_Link">
                          <!-- Pay by Link Starts -->
                          <div class="margin-10">
                            <div class="col p-0 template3 border-outline">
                              <div class="px-4 py-3">
                                <h5 class="pay-by-link-title margin-0">{{'order.Pay By Link' | translate |translateKey}}</h5>
                              </div>
                              <div class="px-4 py-3">
                                <p class="margin-0">{{'order.Customer is paying for the order with pay by link' | translate |translateKey}}</p>
                                <p class="pay-by-link-title margin-0">{{'order.Order wil NOT be shipped until we receive payment' | translate
                                  |translateKey}}</p>
                              </div>
                              <form *ngIf="emailForm" [formGroup]="emailForm">
                                <div class="pl-2 form-group col-xs-6 padding-left-0 floating-input floatLabelContainer">
                                  <input id="email-input" tabindex="0" float-label role="textbox" formControlName="payByLinkEmail"
                                    class="form-control" (input)="emailCheck()" pattern="^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$"
                                    placeholder="{{'order.email address' |translate |translateKey}}{{' *'}}" type="text" />
                                  <span class="error"
                                    *ngIf="emailForm && emailForm.controls['payByLinkEmail'] && !emailForm.controls['payByLinkEmail'].valid && emailForm.controls['payByLinkEmail'].touched">{{'order.Required'
                                    | translate | translateKey}}
                                  </span>
                                  <span tabindex="0" class="error" *ngIf="emailForm.controls['payByLinkEmail'].hasError('pattern')">
                                    {{'order.Please enter a valid email address' | translate | translateKey}}
                                  </span>
                                </div>
                              </form>
                            </div>
                          </div>
                          <!-- Pay By Link Ends -->
                        </div>
                        <div class="col-xs-12 floating-input customFocus"
                        *ngIf="paymentMethodTypeForm.controls['paymentMethodType'].value==paymentTypeEnum.Saved_Cards
                        || (enableNexioPaymentForPickUpCenter && paymentMethodTypeForm.controls['paymentMethodType'].value == paymentTypeEnum.Nexio_Credit_Card)">
                        <div *ngIf="paymentComponentSettings.savedCards && paymentComponentSettings.savedCards.length>0">
                          <div class="border-outline pr-0">
                          <div class="slim-scroll saved-card" slimScroll width="100%" size="3px" height="inherit"
                            alwaysVisible="true" wheelStep="20">
                            <div class="pr-3">
                              <div class="saved-card__content px-0"
                                *ngFor="let savedCard of paymentComponentSettings.savedCards; let i = index;">
                                <div class="row">
                                  <div class="form-check pl-0 w-100">
                                    <div class="row no-margin mt-10 paymentdetails-block expired-card-top" [class.expiry-card] ="savedCard.expired">
                                      <div class="col-xs-1 padding-top-5">
                                        <input tabindex="0" [attr.disabled]="savedCard.expired === true?'':null" type="radio"
                                          name="paymentInstrumentId" formControlName="paymentInstrumentId" [value]="savedCard.id"
                                          [checked]="savedCard.id==posOrderFormGroup.controls['paymentInstrumentId'].value"
                                          (click)="selectSavedCard(savedCard,false)">
                                        <span class="label-text float-left"></span>
                                      </div>
                                      <div class="col-xs-6">
                                        <span class="saved-card__display">
                                          <span class="saved-card__holder-name bold" *ngIf="savedCard.nameOnTheCard">
                                            {{savedCard.nameOnTheCard}}
                                          </span>
                                          <div class="saved-card__mask line-height-cc" *ngIf="savedCard.maskedCard">
                                            <span class="cc-number {{savedCard.cardType | uppercase}} identified card-icon"></span>
                                            <span class="saved-card__ending">
                                              {{'common.Ending in' | translate |translateKey}}
                                              <span
                                                class="helvetica-bold">{{savedCard.maskedCard | slice:savedCard.maskedCard.length - 4}}</span>
                                            </span>
                                          </div>
                                          <div class="saved-card__expiry" *ngIf="savedCard.expiryMonth&&savedCard.expiryYear">
                                            <span class="helvetica-regular">{{'checkout.Expiration' |translate |translateKey}}
                                            </span>
                                            {{savedCard.expiryMonth|number:'2.0-0'}}/{{savedCard.expiryYear.toString().substring(2,4)}}
                                          </div>
                                        </span>
                                      </div>
                                      <div class="col-xs-5" *ngIf="savedCard.expired">
                                        <span [ngClass]="{'color-red':savedCard.expired}">{{'checkout.This Card is no longer valid.Please update payment information' |translate}}</span>
                                      </div>
                                    </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-5 pb-3 padding-top-15" *ngIf="!ignoreAddNewCards && (memberTypeId !== memberTypeEnum.GUEST) && !checkoutConfig?.disableAddNewCards">
                          <input id="saveCard" name="saveCard" [checked]="savePaymentMethod" tabindex="0" type="checkbox"
                            (click)="savePaymentMethodClicked(savePaymentMethod)">
                          <span class="savecard-label">{{'customer-service.Save Payment details?' |translate |translateKey}}</span>
                        </div>
                        <div class="col-xs-7 pr-0 pb-3 padding-top-15 text-right" *ngIf=" !ignoreAddNewCards && !checkoutConfig?.disableAddNewCards" >
                          <button role="button" attr.aria-label="{{'checkout.Add New Card' | translate | translateKey}}" tabindex="0"
                            (mousedown)="addNewCardClicked = true" (keyup.enter)="selectSavedCard(null,true)" type="button"
                            class="btn blue-button" (click)="selectSavedCard(null,true)">
                            <span>+ </span> {{'checkout.Add New Card' |translate |translateKey}}</button>
                        </div>
                      </div>

                        <div class="col-xs-12 floating-input customFocus"
                        *ngIf="paymentMethodTypeForm.controls['paymentMethodType'].value==paymentTypeEnum.Direct_Debit">
                          <!-- DIRECT DEBIT STARTS -->
                          <div class="margin-10">
                            <div class="col p-0 template3 border-outline">
                              <div class="px-4 py-3">
                                <h3 class="title"> {{'checkout.Direct Debit' | translate |translateKey}} </h3>
                                {{'checkout.Customer is paying for the order with Direct Debit' | translate |translateKey}}<br>
                                {{"checkout.We will withdraw money from customer's existing bank account" | translate |translateKey}}
                              </div>
                              <div class="py-3">
                                <div id="agreementBlock" *ngIf="paymentTermsAndPoliciyDocuments" class="agreement-block">
                                  <div class="py-1" *ngFor="let paymentDocument of paymentTermsAndPoliciyDocuments;let i=index;">
                                    <label tabindex="0" class="check-lbl form-check-box">
                                      <input role="checkbox" type="checkbox" aria-label="" class="check-box" name="" id=""
                                        (change)="checkPaymentTermsAndPolicies(i);" [checked]="paymentDocument?.isSelected">
                                      <span class="label-text"></span>
                                      <span class="form-check-text"> {{'customer-service.I have read and agree to' | translate | translateKey}}
                                        <span class="" *ngIf="paymentDocument?.documentUrl">
                                          <a class="learn-more align-top d-inline-block" target="_blank"
                                            [href]="paymentDocument?.documentUrl">{{paymentDocument?.displayName}}</a>
                                        </span>
                                        <span *ngIf="!(paymentDocument?.documentUrl)">{{paymentDocument?.displayName}}</span>
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- DIRECT DEBIT ENDS -->
                        </div>
                      </div>
                    </div>
                    </div>
                </div>
                <!-- Saved cards payments ends -->

                <!-- Split payment section starts -->
                <div *ngIf="+posOrderFormGroup.controls['paymentSelector'].value===posPaymentGroupEnum.Split_Payment && splitPaymentForm.controls['payments'].controls['length']>0">
                  <form [formGroup]="splitPaymentForm">

                    <div class="row no-margin">
                      <div class="col-lg-4">
                        {{'No of payments'}}
                      </div>
                      <div class="col-lg-1">
                        <span (click)="removeSplitPaymentGroup()"><a [ngClass]="splitPaymentForm.controls['payments'].controls[splitPaymentForm.controls['payments'].controls['length']-1].controls['amount'].value!=='' ? 'disabled' : '' " ><i class="fa fa-minus fa-1x"></i></a></span>
                      </div>
                      <div class="col-lg-1">
                        {{splitPaymentForm.controls['payments'].controls.length}}
                      </div>
                      <div class="col-lg-1">
                        <span (click)="addNewSplitPaymentGroup()" ><a [ngClass]="splitPaymentForm.controls['payments'].controls.length>4 ? 'disabled' : '' "><i  class=" fa fa-plus fa-1x"></i></a></span>
                      </div>
                    </div>
                    <div formArrayName="payments">
                      <div *ngFor=" let splitPayment of splitPaymentForm.controls['payments'].controls;let s = index">
                        <div [formGroupName]="s">
                          <div class="row no-margin payment-border-bottom">
                            <div class="col-lg-5 col-md-5">
                              <select id="posLocation" class="form-control" formControlName="paymentMethodId"
                                (change)="onSplitPaymentMethodChange($event,s)">
                                <option [disabled]="true" value='0'>{{'order.Select' |translate |translateKey}}</option>
                                <ng-container *ngFor="let paymentMethod of posPaymentMethods; let k = index">
                                  <option *ngIf="paymentMethod.paymentMethodsModel.paymentGroupID===posPaymentGroupEnum.Split_Payment"
                                    [value]="paymentMethod.paymentMethodsModel.paymentMethodId">
                                    {{paymentMethod.paymentMethodsModel.paymentMethodName}}
                                  </option>
                                </ng-container>
                              </select>
                            </div>
                            <div class="col-lg-3 col-md-3">
                              <input id="amount-{{s}}" formControlName="amount" (change)="onPaymentMethodAmountChange($event,posPaymentGroupEnum.Split_Payment,s)" name="amount" type="text" class="form-control"
                                placeholder="Amount" />
                            </div>
                            <div class=" col-lg-2 col-md-2">
                              <ng-container
                                *ngIf="splitPaymentForm.controls['payments'].controls[s].controls['paymentStatus'].value===false || !splitPaymentForm.controls['payments'].controls[s].controls['paymentStatus'].value ">
                                <button class="form-control"
                                  [disabled]="!splitPaymentForm.controls['payments'].controls[s].controls['amount'].valid" type="button"
                                  (click)="onPaymentConfirmClick(s)">Confirm</button>
                              </ng-container>
                              <ng-container
                                *ngIf="splitPaymentForm.controls['payments'].controls[s].controls['paymentStatus'].value===true">
                                {{'Paid'}} <i class="fa fa-check"></i>
                              </ng-container>
                            </div>
                            <input hidden formControlName="paymentNote">
                            <input hidden formControlName="paymentStatus">
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <!-- split payment section ends -->
              </div>
            </div>
            <div class="column-equal grayborder-1 mt-20 flex-right-28-no-border">
              <div class="table-responsive">
                <table class="table table-striped table-bordered custab">
                  <thead>
                    <tr>
                      <th>{{'customer-service.Order Summary' |translate |translateKey}}</th>
                      <th>{{'customer-service.Amount' |translate |translateKey}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="memberTypeId != memberTypeEnum.GUEST && memberTypeId != memberTypeEnum.RETAIL">
                      <td>{{'customer-service.Retail Subtotal' |translate |translateKey}}</td>
                      <td class="text-right">{{(retailSubTotal ? retailSubTotal:0) | currencyFormat:storeInfo}}
                      </td>
                    </tr>
                    <tr>
                      <td>{{'customer-service.Sub Total' |translate |translateKey}}</td>
                      <td class="text-right">{{calculateItemsSubTotal(storeInfo) | currencyFormat:storeInfo}}
                      </td>
                    </tr>
                    <tr>
                      <td>{{'customer-service.Handling' |translate |translateKey}}</td>
                      <td class="text-right">{{(handlingCharges ? handlingCharges : 0) | currencyFormat:storeInfo}}
                      </td>
                    </tr>
                    <tr *ngIf="appConfig && appConfig.displayTax">
                      <td>{{'customer-service.Taxes' |translate |translateKey}}</td>
                      <td class="text-right" >{{(taxableAmount ? taxableAmount:0) | currencyFormat:storeInfo}}</td>
                    </tr>
                    <ng-container
                      *ngIf="storeInfo?.taxInclusive && appConfig?.displayVat && orderTaxResponse?.taxMetaData?.orderTaxCharges && countryTaxInclusive && !appConfig?.displayTaxInclusivePrice">
                      <tr
                        *ngFor="let item of orderTaxResponse?.taxMetaData?.orderTaxCharges | orderBy:'taxRate' | groupBy:['taxChargeType','taxRate'];let i=index;trackBy:trackByItem">
                        <td *ngIf="item.value[0].taxRate > 0">{{'customer-service.VAT' | translate | translateKey}} <span *ngIf="appConfig.displayTaxCode"> ({{item.value[0].taxChargeType}})
                          {{item.value[0].taxRate}}% </span> <span *ngIf="!appConfig.displayTaxCode">({{item.value[0].taxRate}}%)</span></td>
                        <td class="text-right" *ngIf="item.value[0].taxRate > 0">{{ getItemVolumeSum(item.value) | currencyFormat:storeInfo}}
                        </td>
                      </tr>
                    </ng-container>
                    <ng-container
                      *ngIf="storeInfo?.taxInclusive && appConfig?.displayCustomTaxName && orderTaxResponse?.taxMetaData?.orderTaxCharges && countryTaxInclusive">
                      <tr
                        *ngFor="let item of orderTaxResponse?.taxMetaData?.orderTaxCharges | orderBy:'taxRate' | groupBy:['taxChargeType','taxRate'];let i=index;trackBy:trackByItem">
                        <td *ngIf="item.value[0].taxChargeType === taxType.NOR && item.value[0].taxRate > 0">{{'customer-service.GST' | translate}}</td>
                        <td *ngIf="item.value[0].taxChargeType === taxType.NOR && item.value[0].taxRate > 0" class="text-right">{{ getItemVolumeSum(item.value) | currencyFormat:storeInfo}}
                        </td>
                      </tr>
                    </ng-container>
                    <tr *ngIf="appConfig && appConfig.displayGST">
                      <td>{{'customer-service.GST/HST' |translate |translateKey}}</td>
                      <td class="text-right">{{(gstTax ? gstTax:0) | currencyFormat:storeInfo}}
                      </td>
                    </tr>
                    <tr *ngIf="appConfig && appConfig.displayPST">
                      <td>{{'customer-service.PST/QST' |translate |translateKey}}</td>
                      <td class="text-right">{{(pstTax ? pstTax:0) | currencyFormat:storeInfo}}
                      </td>
                    </tr>
                    <tr>
                      <td>{{'customer-service.Fees' |translate |translateKey}}</td>
                      <td class="text-right">{{(importFeeValue?importFeeValue:0) | currencyFormat:storeInfo}}
                      </td>
                    </tr>
                    <tr class="bold" *ngIf="appConfig?.displayTaxInclusivePrice">
                      <td>{{'customer-service.Total CC' |translate |translateKey}}</td>
                      <td class="text-right"><span *ngIf="storeInfo">{{totalCommissionableVolume
                              | ccFormat:storeInfo:false}}</span></td>
                    </tr>
                    <tr class="bold">
                      <td>{{'customer-service.Total' |translate |translateKey}}</td>
                      <td class="text-right">{{ calculateOrderTotal() | currencyFormat:storeInfo}}</td>
                    </tr>
                    <tr class="bold"  *ngIf="!appConfig?.displayTaxInclusivePrice">
                      <td>{{'customer-service.Total CC' |translate |translateKey}}</td>
                      <td class="text-right"><span *ngIf="storeInfo">{{totalCommissionableVolume
                                      | ccFormat:storeInfo:false}}</span></td>
                    </tr>
                    <ng-container
                      *ngIf="storeInfo?.taxInclusive && appConfig?.displayVat && orderTaxResponse?.taxMetaData?.orderTaxCharges && countryTaxInclusive && appConfig?.displayTaxInclusivePrice">
                      <tr
                        *ngFor="let item of orderTaxResponse?.taxMetaData?.orderTaxCharges | orderBy:'taxRate' | groupBy:['taxChargeType','taxRate'];let i=index;trackBy:trackByItem">
                        <td *ngIf="item.value[0].taxRate > 0">{{'customer-service.Includes' | translate | translateKey}} <span *ngIf="appConfig?.displayTaxCode">{{item.value[0].taxRate}} % {{'customer-service.VAT' | translate | translateKey}}</span>
                          <span *ngIf="!appConfig?.displayTaxCode">({{item.value[0].taxRate}}%)</span></td>
                        <td class="text-right" *ngIf="item.value[0].taxRate > 0">{{ getItemVolumeSum(item.value) | currencyFormat:storeInfo}}
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="mb-20 mt-20 text-right customFocus">
            <span *ngIf="paymentFormBtn && paymentFormBtn.disabled"
              class="fa fa-question-circle-o mr-2 place-order-error" triggers="mouseenter:mouseleave"
              containerClass="place-order--popover" [popover]="placeOrderDisabledTemplate"></span>
            <button role="button" type="button" class="btn blue-button"
              [disabled]="getPlaceOrderStatus() || !isStoreDiscounPercentagetConfigured"
              #paymentFormBtn (click)="createPosOrder()">
              <!-- <span *ngIf="showPayments">Place Order</span>
                            <span *ngIf="!showPayments">Continue</span> -->
              <span>{{'order.Place Order' |translate |translateKey}}</span>
            </button>
            <!-- [attr.disabled]=" !taxCalculationStatus && (posOrderFormGroup.valid) && isActive && !isSubmitted?null:''" -->

            <button [disabled]="!isPaymentBlockEnabled" role="button" type="button" class="btn grey-button" (click)="clearAllTheForms(true)">{{'checkout.Cancel'
                            |translate |translateKey}}
            </button>
          </div>
          <div class="mb-20 col-xs-12 no-padding">
            <!-- Error Validations Starts -->
            <div class="col-md-12" *ngIf="fieldErrors&&fieldErrors.length>0">
              <div class="error" *ngFor="let validation of fieldErrors">
                {{validation.message}}
              </div>
            </div>
            <!-- Error Validations Ends -->
          </div>
          <ng-template #placeOrderDisabledTemplate>
            {{'checkout.Please ensure that data in the mandatory fields are entered and the address is verified' |translate |translateKey}}
          </ng-template>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- popup for payment -->
<modal #paymentModal class="" *ngIf="posOrderFormGroup.value.orderType!==orderType.NEW_FPC">
  <modal-header>
  </modal-header>
  <modal-content>
    <!-- Payvision form starts -->
    <div class="p-0">
      <div id="pvscript"> </div>
    </div>
    <!-- Payvision form Ends -->
  </modal-content>
  <modal-footer>
  </modal-footer>
</modal>
<modal *ngIf="posOrderFormGroup.value.orderType!==orderType.NEW_FPC" [closeOnEscape]="false"
  [closeOnOutsideClick]="false" #payvisionPayment (onClose)="onPayvisionFormClose()">
  <modal-header>
    <span class="pull-right pointer" *ngIf="paymentComponentSettings && paymentComponentSettings.payvisionFormLoaded" (click)="onPayvisionFormClose()">X</span>
  </modal-header>
  <modal-content>
    <!-- Payvision form starts -->
    <payment-payvision *ngIf="addNewpayvisionCard" [paymentComponentSettings]="paymentComponentSettings">
    </payment-payvision>
    <!-- Payvision form Ends -->
  </modal-content>
  <modal-footer>
  </modal-footer>
</modal>
<modal *ngIf="posOrderFormGroup.value.orderType!==orderType.NEW_FPC" #eCheckPaymentPopup (onClose)="onECheckFormClose()"
  class="echeck-modal">
  <modal-header>
    <div class="color-blue">{{'order.ECHECK PAYMENT' |translate}}</div>
  </modal-header>
  <modal-content>
    <!-- eCheck form starts -->
    <div *ngFor="let message of eCheckValidationMessages">
      <li class="alert-msg pad-bot-8">
        {{message}}
      </li>
    </div>
    <div *ngIf="addNeweCheck">
      <form [formGroup]="echeckForm" (ngSubmit)="validateNewECheck()">
        <div class="row">
          <div class="col-md-6 floating-input floatLabelContainer">
            <input #routerNumberInput id="routerNumberInput" float-label type="text" formControlName="routerNumber"
              class="form-control" placeholder="Routing Number*" />
            <div class="alert-msg"
              *ngIf="!echeckForm.controls['routerNumber'].valid && echeckForm.controls['routerNumber'].hasError('required') && (echeckForm.controls['routerNumber'].touched || echeckSubmitted)">
              {{'order.Required' |translate}}
            </div>
            <div class="alert-msg"
              *ngIf="!echeckForm.controls['routerNumber'].valid && echeckForm.controls['routerNumber'].hasError('alphaNumericValidation') && (echeckForm.controls['routerNumber'].touched || echeckSubmitted)">
              {{'order.Invalid Routing Number' |translate}}
            </div>
            <div class="alert-msg"
              *ngIf="!echeckForm.controls['routerNumber'].valid && echeckForm.controls['routerNumber'].hasError('maxlength') && !echeckForm.controls['routerNumber'].hasError('alphaNumericValidation') && (echeckForm.controls['routerNumber'].touched || echeckSubmitted)">
              {{'order.Length cannot be greater than 9' |translate}}
            </div>
          </div>
          <div class="col-md-6  floating-input floatLabelContainer">
            <input float-label type="text" formControlName="accountNumber" class="form-control"
              placeholder="Account Number*" />
            <div class="alert-msg"
              *ngIf="!echeckForm.controls['accountNumber'].valid && echeckForm.controls['accountNumber'].hasError('required') && (echeckForm.controls['accountNumber'].touched || echeckSubmitted)">
              {{'order.Required' |translate}}
            </div>
          </div>
          <div class="col-md-6  floating-input">
            <select tabindex="0" attr.aria-label="{{'echeck.Select Account Type' | translate | translateKey}}"
              attr.data-placeholder="{{'echeck.Select Account Type' | translate | translateKey}}*" role="listbox"
              class="form-control" formControlName="accountType">
              <option role="option" disabled>{{'echeck.Select Account Type' | translate | translateKey}}*</option>
              <option role="option" *ngFor="let accounttype of accountTypes" [value]="accounttype">{{accounttype
                                | titlecase}}</option>
            </select>
            <div class="alert-msg"
              *ngIf="!echeckForm.controls['accountType'].valid && echeckForm.controls['accountType'].hasError('required') && (echeckForm.controls['accountType'].touched || echeckSubmitted)">
              {{'order.Required' |translate}}
            </div>
          </div>
          <div class="col-md-6 floating-input floatLabelContainer">
            <input float-label type="text" formControlName="nameOnBankAccount" class="form-control"
              placeholder="Name on bank Account*" />
            <div class="alert-msg"
              *ngIf="!echeckForm.controls['nameOnBankAccount'].valid && echeckForm.controls['nameOnBankAccount'].hasError('required') && (echeckForm.controls['nameOnBankAccount'].touched || echeckSubmitted)">
              {{'order.Required' |translate}}
            </div>
            <div class="alert-msg"
              *ngIf="!echeckForm.controls['nameOnBankAccount'].valid && echeckForm.controls['nameOnBankAccount'].hasError('alphaNumericValidation') && (echeckForm.controls['nameOnBankAccount'].touched || echeckSubmitted)">
              {{'order.Only Alphanumeric characters are allowed' |translate}}
            </div>
            <div class="alert-msg"
              *ngIf="!echeckForm.controls['nameOnBankAccount'].valid && echeckForm.controls['nameOnBankAccount'].hasError('maxlength') && !echeckForm.controls['nameOnBankAccount'].hasError('alphaNumericValidation') && (echeckForm.controls['nameOnBankAccount'].touched || echeckSubmitted)">
              {{'order.Length cannot be greater than 25' |translate}}
            </div>
          </div>
          <div class="col-md-6 floating-input floatLabelContainer">
            <input float-label type="text" formControlName="bankName" class="form-control" placeholder="Bank Name*" />
            <div class="alert-msg"
              *ngIf="!echeckForm.controls['bankName'].valid && echeckForm.controls['bankName'].hasError('required') && (echeckForm.controls['bankName'].touched || echeckSubmitted)">
              {{'order.Required' |translate}}
            </div>
          </div>
          <div class="col-md-6 floating-input floatLabelContainer">
            <input float-label type="text" formControlName="email" class="form-control" placeholder="Email*"
              pattern="^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$" [maxlength]="50" required />
            <div class="alert-msg"
              *ngIf="!echeckForm.controls['email'].valid && echeckForm.controls['email'].hasError('required') && (echeckForm.controls['email'].touched || echeckSubmitted)">
              {{'order.Required' |translate}}
            </div>
            <div class="alert-msg"
              *ngIf="!echeckForm.controls['email'].valid && echeckForm.controls['email'].hasError('pattern') && (echeckForm.controls['email'].touched || echeckSubmitted)">
              {{'checkout.Please enter a valid email address' | translate | translateKey}}
            </div>
          </div>
          <div class="col-md-6 floating-input floatLabelContainer">
            <input float-label type="text" formControlName="phone" [maxlength]="15" class="form-control"
              placeholder="Phone Number*" (input)="onChangeEcheckPhone($event)" />
            <div class="alert-msg"
              *ngIf="!echeckForm.controls['phone'].valid && echeckForm.controls['phone'].hasError('required') && (echeckForm.controls['phone'].touched || echeckSubmitted)">
              {{'order.Required' |translate}}
            </div>
            <div class="alert-msg"
              *ngIf="!echeckForm.controls['phone'].valid && echeckForm.controls['phone'].hasError('InvalidPhoneNo') && (echeckForm.controls['phone'].touched || echeckSubmitted)">
              {{'order.Please enter valid Phone Number' | translate | translateKey}}
            </div>
          </div>
          <div class="col-md-12">
            <span aria-label="billing address" class="pl-0 card-color address-label helvetica-bold"><b>{{'echeck.Billing
                                Address'|translate}}
              </b></span>
          </div>
          <div class="col-md-12">
            <div class="pt-5">
              <app-address-new class="shipping-address-schema" (addressSubmit)="saveBillingAddress($event)"
                [schemaUrl]="billingSchemaUrl" [countryCode]="countryCode" [onCountryChange]="true"
                [skipAddressVerification]="true"></app-address-new>
            </div>
          </div>
          <div class="col-md-12 text-right hide">
            <button #saveEcheckFormBtn tabindex="0" class="btn blue-button" type="submit">
              {{'config-system.Submit' |translate |translateKey}}
            </button>
            <button tabindex="0" class="btn grey-button" type="button" (click)="onECheckFormClose()"
              data-dismiss="modal" aria-label="Close">
              {{'config-system.cancel' |translate |translateKey}}
            </button>
          </div>
          <div class="col-xs-12">
            <input type="checkbox" formControlName="reuse" class="" /><span>{{'config-system.Save for
                            future use' |translate |translateKey}}</span>
            <span title="{{'payment.Save for future use'|translate| translateKey}}"
              class="ico-help fa fa-question-circle-o font-size-18"></span>
          </div>
        </div>
      </form>
    </div>
    <!-- eCheck form Ends -->
  </modal-content>
  <modal-footer>
  </modal-footer>
</modal>
<modal *ngIf="posOrderFormGroup.value.orderType!==orderType.NEW_FPC" [closeOnEscape]="false"
  [closeOnOutsideClick]="false" #showWorldPayXMLPopup (onClose)="onWorldpayXMLFormClose()">
  <modal-header>
    <span class="pull-right pointer" (click)="onWorldpayXMLFormClose()">X</span>
  </modal-header>
  <modal-content>
    <!-- Worldpay XML form starts -->
    <payment-worldpay-xml *ngIf="showWorldpayXml" [paymentComponentSettings]="paymentComponentSettings">
    </payment-worldpay-xml>
    <!-- Worldpay XML form Ends -->
  </modal-content>
  <modal-footer>
  </modal-footer>
</modal>
<modal
    [closeOnEscape]="false" [closeOnOutsideClick]="false" #showAdyenPaymentPopup (onClose)="onAdyenPaymentFormClose()">
    <modal-header>
        <span class="pull-right pointer" (click)="onAdyenPaymentFormClose()">X</span>
    </modal-header>
    <modal-content>
        <!-- Adyen Payment form starts -->
        <app-adyen-payment *ngIf="showAdyenPayment" [adyenPaymentComponentSettings]="paymentComponentSettings" [orderType]="orderType.POS" [sessionGuid]="sessionGuid">
        </app-adyen-payment>
        <!-- Adyen Payment form Ends -->
    </modal-content>
    <modal-footer>
    </modal-footer>
</modal>
<modal *ngIf="posOrderFormGroup.value.orderType!==orderType.NEW_FPC" [closeOnEscape]="false"
  [closeOnOutsideClick]="false" #showNIPopup (onClose)="onNIFormClose()">
  <modal-header>
    <span class="pull-right pointer" (click)="onNIFormClose()">X</span>
  </modal-header>
  <modal-content>
    <!-- NI form starts -->
    <payment-network-international *ngIf="showNIPayment" [paymentComponentSettings]="paymentComponentSettings">
    </payment-network-international>
    <!-- NI form Ends -->
  </modal-content>
  <modal-footer>
  </modal-footer>
</modal>

<modal *ngIf="posOrderFormGroup.value.orderType!==orderType.NEW_FPC && enableNexioPaymentForPickUpCenter" 
[closeOnEscape]="false" [closeOnOutsideClick]="false" #showNexioPopup (onClose)="onNexioFormClose()">
  <modal-header>
      <span class="pull-right pointer" (click)="onNexioFormClose()">X</span>
  </modal-header>
  <modal-content>
       <app-nexio *ngIf="showNexioPayment" [paymentComponentSettings]="paymentComponentSettings"
       (savedcardSubmit)="savedCardInfo($event)" 
       [products]="products"></app-nexio>  
  </modal-content>
  <modal-footer>
  </modal-footer>
</modal>


<ng-template #notAvailable>{{'order.NA' |translate |translateKey}}</ng-template>
<!-- STOCK AVAILABILITY CHECK START -->
<modal [closeOnEscape]="false" [closeOnOutsideClick]="false" #outOfStockModal>
  <modal-header>
    <div class="color-blue text-uppercase">{{'order.Out of stock' |translate |translateKey}}</div>
  </modal-header>
  <modal-content>
    <div class="red-color top-minus-10">
      {{'This item(s) cannot be picked up from the selected location, remove items from cart'}}
  </div>
  <div class="mb-5" *ngFor="let item of outOfStockItems;">
      <span>{{item.displayName}} - #{{item.itemNumber}} - </span><span class="text-red">{{'available quantity'}} - {{item.stockQuantity}}</span>
  </div>
    <div class="text-right mt-20">
      <button role="button" type="button" class="btn blue-button" (click)="clearOutOfStockItems()">
        {{'order.ok'|translate |translateKey}}
      </button>
      <button tabindex="0" class="btn grey-button" type="button" (click)="closeOutOfStockForm()" data-dismiss="modal" aria-label="Close">
        {{'config-system.cancel' |translate |translateKey}}
      </button>
    </div>
  </modal-content>
  <modal-footer>
  </modal-footer>
</modal>
<modal  [closeOnEscape]="false" [closeOnOutsideClick]="false" #overrideMinimumLimit>
    
  <modal-header>
      <div class="color-blue">{{'order.CHANGE OVERRIDE MINIMUM LIMIT' |translate |translateKey}}  <span class="pull-right pointer"  (click)="closeOverrideMinimumLimit()">X</span></div> 
  </modal-header>
  <modal-content>
  <div class="row">
      <div class="col-md-10 mb-10 p-5">
          <h4 style="font-size: 19px;" class="bold">{{'order.To override the minimum limit, please select the box below' |translate |translateKey}}:</h4>
          <div>
              <input type="checkbox" [(ngModel)]="isOverrideMinimumLimit" (change)="overrideMinimumLimitValueCheck($event)" />&nbsp;<span style="font-size: 14px;" >{{'order.Override order minimum' |translate |translateKey}}</span>
          </div>
      </div>
  </div>   
  <div class="clearboth pull-right pad-r-8">
      <button class="btn blue-button" tabindex="0" type="button" (click)="closeNotification()" >
          {{'order.OK' |translate |translateKey}}
      </button>
      <button class="btn grey-button" tabindex="0" type="button" (click)="closeOverrideMinimumLimit()">
          {{'config-system.CANCEL' |translate |translateKey}}
      </button>
  </div>
  </modal-content>
  <modal-footer>
  </modal-footer>
</modal>

<!-- STOCK AVAILABILITY CHECK END -->
<modal [closeOnEscape]="false" [closeOnOutsideClick]="false" #paymentProcessing>
  <modal-header>
      <div class="color-black">{{'order.Processing transaction...' | translate | translateKey}}</div>
  </modal-header>
  <modal-content>
    <div class="progressBar animate">
      <span style="width: 100%"><span></span></span>
    </div>
    <div class="pull-right">
      <button [disabled]="terminalTransactionCancelButton" class="btn blue-button" type="button" tabindex="0" (keyup.enter)="cancelTerminalPayment()" (click)="cancelTerminalPayment()">
          {{'checkout.Cancel' | translate}}
      </button>
  </div>
  </modal-content>
</modal>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/pos-orders/pos-order-promotion.component.html